import { area, bbox, bboxClip, bboxPolygon } from "@turf/turf";

const MIN_VIEWPORT_COVERAGE = 0.1;

export function prepareFootprints(coverages) {
  return (coverages || [])
    .filter((coverage) => coverage.footprint)
    .map((coverage) => ({
      id: coverage.id,
      geometry: coverage.footprint,
      bbox: bbox(coverage.footprint),
    }));
}

function viewportCoverage(footprint, view, viewArea) {
  const [west, south, east, north] = footprint.bbox;
  const [viewWest, viewSouth, viewEast, viewNorth] = view;

  if (
    west >= viewEast ||
    east <= viewWest ||
    south >= viewNorth ||
    north <= viewSouth
  ) {
    return 0;
  }

  return area(bboxClip(footprint.geometry, view)) / viewArea;
}

// Footprints arrive in pieces, one per map cell, so a coverage's share of
// the view is the sum of its pieces
export function sparseCoverageIds(footprints, view, ids) {
  const viewArea = area(bboxPolygon(view));
  const fractions = new Map();

  footprints.forEach((footprint) => {
    fractions.set(
      footprint.id,
      (fractions.get(footprint.id) || 0) +
        viewportCoverage(footprint, view, viewArea),
    );
  });

  return ids.filter((id) => (fractions.get(id) || 0) < MIN_VIEWPORT_COVERAGE);
}
